export default __webpack_public_path__ + "static/media/topArrow.10355134.svg";